import { Container } from 'inversify';
import { Provider } from 'inversify-react';
import React from 'react';

export const globalDIContainer = new Container();
const DIProvider: React.FC<React.PropsWithChildren<unknown>> = ({ children }) => {
  return <Provider container={globalDIContainer}>{children}</Provider>;
};
export default DIProvider;
